import { AzureAuthParams, AzureAuthResponse, BatchMaterialParams, SingleMaterialParams } from "data/BuyNowApiTesting";
import { send } from 'lib/API';

const API_URL = process.env.REACT_APP_API_URL;

/**
 * Ensure URL has protocol (http:// or https://)
 */
const ensureProtocol = (url: string): string => {
  if (!url) return url;
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }
  // Default to https if no protocol
  return `https://${url}`;
};

/**
 * Authenticate with Azure AD to get access token (via backend proxy)
 */
export const authenticateAzureAD = async (params: AzureAuthParams, token: string): Promise<AzureAuthResponse> => {
  const request = new Request(`${API_URL}/v1/buyNow/auth/azure`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
    body: JSON.stringify({
      clientId: params.clientId,
      clientSecret: params.clientSecret,
    }),
  });

  return await send(request);
};

/**
 * Fetch single material details (via backend proxy)
 */
export const fetchSingleMaterial = async (params: SingleMaterialParams, token: string): Promise<any> => {
  const body: any = {
    materialNumbers: params.materialNumber,
    baseUrl: ensureProtocol(params.baseUrl),
    azureAccessToken: params.accessToken,
    country: params.country,
    level: params.level
  };

  // Add level-specific parameters
  if (params.level === 'vendor') {
    body.vendorCode = params.vendorCode;
    body.vendorKey = params.vendorKey;
  } else {
    body.brandCode = params.brandCode;
    body.brandKey = params.brandKey;
  }

  const request = new Request(`${API_URL}/v1/buyNow/materials/${params.materialNumber}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`, // User's auth token for backend validation
    },
    body: JSON.stringify(body),
  });

  return await send(request);
};

/**
 * Fetch batch materials (via backend proxy)
 */
export const fetchBatchMaterials = async (params: BatchMaterialParams, token: string): Promise<any> => {
  const body: any = {
    materialNumbers: params.materialNumbers,
    baseUrl: ensureProtocol(params.baseUrl),
    azureAccessToken: params.accessToken,
    country: params.country,
    level: params.level
  };

  // Add level-specific parameters
  if (params.level === 'vendor') {
    body.vendorCode = params.vendorCode;
    body.vendorKey = params.vendorKey;
  } else {
    body.brandCode = params.brandCode;
    body.brandKey = params.brandKey;
  }

  const request = new Request(`${API_URL}/v1/buyNow/materials`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`, // User's auth token for backend validation
    },
    body: JSON.stringify(body),
  });

  return await send(request);
};
